// Canvas ambiente: mesh gradient com os orbs da marca (mesma do portal).
export function Background({ children }) {
  return <div className="mesh-gradient relative min-h-dvh w-full">{children}</div>
}
